import Api from "./Api";
import Csrf from "./Csrf";

export default {   
    
  async update(id,form) {
    await Csrf.getCookie();

    return Api.patch("/partners/"+id, form);
  },
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/partners");
  },
    
  async add(form) {
    await Csrf.getCookie();

    return Api.post("/partners", form);
  },
    
  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/partners/" + id);      
      
  },
    
  async show(id) {
    await Csrf.getCookie();

    return Api.get("/partners/" + id);      
      
  },
    
  async getUsers(id) {
    await Csrf.getCookie();

    return Api.get("/partners/users/" + id);      
      
  },
};